import React from 'react';
import { PropTypes } from 'prop-types';
import _ from 'lodash';
import ReactTooltip from 'react-tooltip'

class HeaderDropDown extends React.Component{
  constructor(props){
    super(props);
  } 

  render(){
    return (
      <th>
        <select {...this.props}>
          <option value='providerId'>Provider ID</option>
          <option value='fullName'>Full Name</option>
          <option value='username'>Username</option>
          <option value='npi'>NPI</option>
          <option value='licenseStates'>Licenses</option>
          <option value='minAge'>Min Age</option>
          <option value='maxAge'>Max Age</option>
          <option value='providerIsActive'>Status</option>
          <option value='clockIn'>Clocked In</option>
          <option value='medicaidNumbers'>Medicaid Number</option>
          <option value='tpnNames'>TPNs</option>
          <option value='primaryRoleName'>Provider Role</option>
          <option value='specialtyNames'>Specialty Names</option>
        </select>
        <a data-tip="React-tooltip">*?</a>
        <ReactTooltip place="top" type="dark" effect="float">
          Select which attribute of the provider you want in this column
        </ReactTooltip>
      </th>
    )
  }
}

function renderResultRow(result, headers){
  return (
    <tr key={result.providerId}>
      {
        _.map(headers, (attribute, idx) => {
          let presentation = result[attribute];
          if(Array.isArray(presentation)){
            presentation = presentation.join(", ");
          }else if(typeof presentation === 'boolean'){
            presentation = Boolean(presentation) ? 'Yes' : 'No';
          }else if(presentation === 'true' || presentation === 'false'){
            presentation = presentation === 'true' ? 'Yes' : 'No';
          }
          return <td key={attribute+idx}>{presentation}</td> 
        })
      }
      <td><a href={`/providers/${result.providerId}`}>View</a></td>
    </tr>
  )
}

class Results extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      headers: ['fullName', 'username', 'providerIsActive', 'providerId']
    }
    this.toggleView = this.toggleView.bind(this);
  }

  toggleView(ev, position){
    let tmp = [...this.state.headers];
    tmp[position] = ev.target.value;
    this.setState({headers: tmp});
  }

  render(){
    const {
      providers
    } = this.props;

    return (
      <div>
        <table className='table striped'>
          <thead>
            <tr>
              <HeaderDropDown
                value={this.state.headers[0]}
                onChange={(ev) => this.toggleView(ev, 0)}
              />
              <HeaderDropDown
                value={this.state.headers[1]}
                onChange={(ev) => this.toggleView(ev, 1)}
              />
              <HeaderDropDown
                value={this.state.headers[2]}
                onChange={(ev) => this.toggleView(ev, 2)}
              />
              <HeaderDropDown
                value={this.state.headers[3]}
                onChange={(ev) => this.toggleView(ev, 3)}
              />
              <th></th>
            </tr>
          </thead>
          <tbody>
            { providers.map( (provider) => renderResultRow(provider, this.state.headers)  ) }
          </tbody>
        </table>
      </div>
    );
  }
}

Results.propTypes = {
  providers:  PropTypes.arrayOf(PropTypes.shape({
                fullName: PropTypes.string,
                licenseStates: PropTypes.arrayOf(PropTypes.string),
                licenseNumbers: PropTypes.arrayOf(PropTypes.string),
                primaryRoleName: PropTypes.string,
                providerId: PropTypes.number,
                npi: PropTypes.string
              }))
}

export default Results;

